import React from 'react';
import SingleProductCardForCarousel from './SingleProductCardForCarousel';
import useWindowWidth from '../../hooks/useWindowWidth';
import useWindowHeight from '../../hooks/useWindowHeight';

export default function OverlayProductCardsForCarousel() {
    const windowWidth = useWindowWidth();
    
    const windowHeight = useWindowHeight()
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div style={{ position: 'absolute', left: 0 }}>
        <SingleProductCardForCarousel
          title="Stijlvol™ | Nina Zomerjurk"
          img="https://cdn.shopify.com/s/files/1/0731/5030/0504/products/O1CN01KkNkzW1OW8t1OdHoF__2200632421712-0-cib.webp?v=1689510815"
        />
      </div>
      <div style={{ position: 'absolute', top:windowHeight <= 745 ? 175 : windowWidth <=1500 ? 180 : 230, left: '50%', transform: 'translate(-50%, -50%)', zIndex: 999 }}>
        <SingleProductCardForCarousel
          title="Eva™ Orthopädische Bequeme Sandalen (50% Rabatt)"
          img="https://cdn.shopify.com/s/files/1/0718/9826/7969/products/nanccy-bequeme-sandalen-fur-frauen-globior-nanccy-bequeme-sandalen-fur-frauen-758629_0aa2d40d-be80-4c6b-8130-e200f82471a3.jpg?v=1686350746"
        />
      </div>
      <div style={{ position: 'absolute', top: windowHeight <= 745 ? 70 : windowWidth <=1500 ? 100: 140, right: 0, zIndex: 999 }}>
        <SingleProductCardForCarousel
          title="SummerCool | Kühldecke"
          img="https://cdn.shopify.com/s/files/1/0668/2548/6602/products/6-descript-sommer-kuhlung-decke-klimaanlage-troster-quilt-leichte-und-atmungsaktive-stricken-sofa-bett-decken_84093d92-599c-42d2-9b18-9f65f17d0944.png?v=1687255004"
        />
      </div>
    </div>
  );
}
